import * as React from 'react'
import SkillsButton from './SkillsButton'

const Skills: React.FunctionComponent = () => {
  return (
    <div className="row white box-shadow" id="skills">
      <div className="side-content"></div>
      <div className="main-content">
        <div className="content-header">
          <a className="anchor"></a>
          <h2 className="m-4">Skills, Languages & Frameworks</h2>
        </div>
        <div className="content-body">
          <ul className="ul-skills">
            <SkillsButton skill="HTML" link="https://developer.mozilla.org/en-US/docs/Web/HTML" />
            <SkillsButton skill="CSS" link="https://developer.mozilla.org/en-US/docs/Web/CSS/Cascade" />
            <SkillsButton skill="Javascript" link="https://developer.mozilla.org/en-US/docs/Web/JavaScript" />
            <SkillsButton skill="Typescript" link="https://www.typescriptlang.org" />
            <SkillsButton skill="Node.js" link="https://nodejs.org" />
            <SkillsButton skill="React.js" link="https://reactjs.org" />
            <SkillsButton skill="Express.js" link="https://expressjs.com" />
            <SkillsButton skill="Bootstrap" link="https://getbootstrap.com" />
            <SkillsButton skill="Webpack" link="https://webpack.js.org" />
            <SkillsButton skill="Parcel" link="https://parceljs.org" />
            <SkillsButton skill="Python" link="https://www.python.org" />
            <SkillsButton skill="Flask" link="https://flask.pocoo.org" />
            <SkillsButton skill="Docker" link="https://www.docker.com" />
          </ul>
        </div>
      </div>
      <div className="side-content"></div>
    </div>
  )
}

export default Skills
